/* eslint-disable import/extensions */
import reader from "./reader.json";

export default reader;
